import React from "react";
import ChangelogInfo from "../../../components/User/ChangelogComponents/ChangelogInfo";

const Changelog = () => {
  return <ChangelogInfo />;
};

export default Changelog;
